import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuoteModal } from '../../../context/QuoteModalContext';

// Desktop keeps the wide hero shots; phones swap to portrait-friendly picks
// (the wide crops cut the tents off on a narrow screen).
const SLIDES = [
  {
    desktop: '/assets/img/1fb6a28822d0.webp',
    mobile: '/assets/img/weddings-13.webp',
    alt: 'Pop Pro Tents stretch tent illuminated at a festival',
  },
  {
    desktop: '/assets/img/weddings-07.webp',
    mobile: '/assets/img/brand-activations-05.webp',
    alt: 'Aerial view of a wedding reception under Pop Pro stretch tents at golden hour',
  },
];

export default function Hero() {
  const [active, setActive] = useState(0);
  const { openModal } = useQuoteModal();

  useEffect(() => {
    const id = setInterval(() => setActive((prev) => (prev + 1) % SLIDES.length), 6000);
    return () => clearInterval(id);
  }, []);

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-28 pb-28">
      {/* Background Image Carousel */}
      <div className="absolute inset-0">
        {SLIDES.map((slide, i) => (
          <picture key={slide.desktop}>
            <source media="(max-width: 767px)" srcSet={slide.mobile} />
            <img
              src={slide.desktop}
              alt={slide.alt}
              className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-1000 ${i === active ? 'opacity-100' : 'opacity-0'}`}
            />
          </picture>
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className="space-y-6">
          <div className="flex justify-center mb-2">
            <img
              src="/assets/img/c27d79fc750c.webp"
              alt="Pop Pro Tents Sub Logo"
              className="w-32 md:w-40 object-contain drop-shadow-lg"
            />
          </div>
          <h1 className="text-2xl md:text-4xl font-extrabold text-white tracking-tight leading-tight max-w-3xl mx-auto">
            Stretch Tent Rentals &amp; Sales in Austin, Texas &amp; Nationwide
          </h1>
          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto">
            Welcome to Pop Pro Tents®, your go-to creative studio specializing in custom stretch tent rentals.
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-4 pt-6">
            <Link to="/products" className="bg-teal-400 hover:bg-teal-500 text-white px-8 py-4 rounded-lg text-base font-semibold transition-all transform hover:scale-105 whitespace-nowrap">
              EXPLORE PRODUCTS
            </Link>
            <button
              type="button"
              onClick={openModal}
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white px-8 py-4 rounded-lg text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              BUY OR RENT
            </button>
          </div>
        </div>
      </div>

      {/* Carousel dots */}
      <div className="absolute bottom-20 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            type="button"
            onClick={() => setActive(i)}
            aria-label={`Show slide ${i + 1}`}
            className={`w-2.5 h-2.5 rounded-full transition-colors cursor-pointer ${i === active ? 'bg-white' : 'bg-white/40 hover:bg-white/60'}`}
          />
        ))}
      </div>
    </section>
  );
}